import React, { useState, useEffect} from "react";
import { useHistory } from "react-router-dom";
import StateContext from "../../helpers/ContextState";
import { PostAsync, format, Inputs } from "../../helpers/Functions";
import { useParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";
import Input from "../../components/InputSimple";
import Select from "../../components/Select";
import SelectorMultiple from "../../components/SelectorMultiple";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash, faPrint, faFileDownload, faCheck, faDollarSign } from "@fortawesome/free-solid-svg-icons";
import Config from "../../helpers/Config";

const App = (props) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const context = React.useContext(StateContext);
  const params = useParams();
  const [data, setData] = useState([]);
  const [btn, setBtn] = useState(false);
  const [paying, setPaying] = useState(false);
  const [btnPagar, setBtnPagar] = useState([]);
  const [proveedor, setProveedor] = useState({});
  const [totalLineas, setTotalLineas] = useState([]);
  const [totalLineasPeso, setTotalLineasPeso] = useState([]);
  const [totalLineasTotal, setTotalLineasTotal] = useState([]);
  const [totalReteIva, setTotalReteIva] = useState([]);
  const [totalGeneral, setTotalGeneral] = useState({
    peso: 0,
    cantidad: 0,
    total: 0,
  });
  const [inputs, setInputs] = useState({});
  const [semanas, setSemanas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [productos, setProductos] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [retentions, setRetentions] = useState([]);
  const [tipoUsuario, setTipoUsuario] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [subTotalFooter, setSubtotalFooter] = useState(0);
  const [totalGeneralFooter, setTotalGeneralFooter] = useState(0);
  const [totalIva, setTotalIva] = useState(0);
  const [fecha, setFecha] = useState("");
  const [fechaVencimiento, setFechaVencimiento] = useState("");
  const [semestre, setSemestre] = useState("");
  const [observacion, setObservacion] = useState("");
  const [observacionCompra, setObservacionCompra] = useState("");
  const [formValidated, setFormValidated] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [productoFilter, setProductoFilter] = useState("");
  const [marcaFilter, setMarcaFilter] = useState("");
  const [semanaFilter, setSemanaFilter] = useState("");
  const [fechaInicioFiltro, setFechaInicioFiltro] = useState("");
  const [fechaFinFiltro, setFechaFinFiltro] = useState("");
  const [dataFiltrada, setDataFiltrada] = useState([]);
  const [opInventarioItemsFilter, setOpInventarioItemsFilter] = useState("");
  const [reteiva, setReteiva] = useState(0);
  const [reteica, setReteica] = useState(0);
  const [retefuente, setRetefuente] = useState(0);
  const [baseRetefuente, setBaseRetefuente] = useState(0);
  const [totalPagar, setTotalPagar] = useState(0);
  const history = useHistory();
  let filter = "";

  useEffect(() => {
    setDataFiltrada(data);
  }, [data]);

  const basicInputs = () => {
    PostAsync(
      "Inventario",
      "ListadoCompras",
      { inTrash: 1, fecha: "0000-00-00", limit: 0, uid: params.id, start: 0 },
      context
    ).then((response) => {
      if (response.data && response.data.semanas) {
        setSemanas(response.data.semanas);
      }

      if (response.data && response.data.marcas) {
        console.log("response.data.marcas",response.data.marcas);
        setMarcas(response.data.marcas);
      }

      if (response.data && response.data.productos) {
        setProductos(response.data.productos);
      }
    });
  };
  
  useEffect(() => {
  const objetosPrincipalesFiltrados = data.reduce((acumulador, objeto) => {
    const itemsFiltrados = objeto.items.filter((item) => {
      const fechaCompra = new Date(item.fecha_compra);
      const fechaInicioValida = !inputs.fecha_inicio || fechaCompra >= new Date(inputs.fecha_inicio);
      const fechaFinValida = !inputs.fecha_fin || fechaCompra <= new Date(inputs.fecha_fin);
      //console.log(item);
      const semanaValida = !inputs.semana ||inputs.semana.length==0|| inputs.semana.some(opt => opt.value == item.semana);
      const marcaValida = !inputs.marca_id || inputs.marca_id.length==0 ||inputs.marca_id.some(opt => opt.value === item.marca_id);
      const opInventarioItemsValido = !inputs.producto_id || inputs.producto_id.length==0||inputs.producto_id.some(opt => opt.value === item.op_inventario_items_id);

      return (
        fechaInicioValida &&
        fechaFinValida &&
        semanaValida &&
        marcaValida &&
        opInventarioItemsValido
      );
    });

    if (itemsFiltrados.length > 0) {
      acumulador.push({
        ...objeto,
        items: itemsFiltrados,
      });
    }

    return acumulador;
  }, []);
  setTotalGeneralFooter(0);
  setTotalIva(0);
  setReteiva(0);
  setReteica(0);
  setRetefuente(0);
  setTotalPagar(0)
  dataFiltrada.map((row) => {
    totalLineas[row.label] = 0;
    totalLineasPeso[row.label] = 0;
    totalLineasTotal[row.label] = 0;
  })
  setTotalLineas(totalLineas);
  setTotalLineasPeso(totalLineasPeso);
  setTotalLineasTotal(totalLineasTotal);

  setDataFiltrada(objetosPrincipalesFiltrados);
}, [data, inputs]);

  useEffect(() => {
    if (params.id) {
      getInit();
      basicInputs();
    }
  }, [productoFilter]);

  const getInit = () => {
    setData([]);

    PostAsync(
      "Pagos",
      "ListaPagosDetalle",
      { ...inputs, id: params.id, fecha_inicio: params.fecha_inicio, fecha_fin: params.fecha_fin },
      context
    ).then((response) => {
      if (params.fecha_inicio && params.fecha_fin) {
        setFechaInicioFiltro(params.fecha_inicio);
        setFechaFinFiltro(params.fecha_fin);//HERE
      }
      // console.log(response);
      setTipoUsuario(response.tipoUsuario);
      setRetentions(response.impuestos);

      if (response.proveedor) {
        setProveedor(response.proveedor);
      }
      
      if (response.data && Object.entries(response.data).length > 0) {
        setTaxes(response.system);
        

        let data_ = [];
        let totalGeneral_ = {};
        let totalLineas_ = [0];

        let totalLineasPeso_ = [0];

        let totalLineasTotal_ = [0];

        let btnPagar_ = [];
        let btnPagar__ = [];
        let activeOnBtn__ = false;

        let totalIva = 0;
        let totalGeneralFooter = 0;
        // let totalLineas = 0
        // let totalLineasPeso =0
        // let totalLineasTotal = 0

        Object.entries(response.data).map((row, key) => {
          console.log("TEST", row, key)

          // console.log(response.data);
          data_.push({ label: row[0], items: row[1] });

          totalLineas_[row[0]] = 0;
          totalLineasPeso_[row[0]] = 0;
          totalLineasTotal_[row[0]] = 0;
          btnPagar_ = [];

          
          row[1].map((row2, key2) => {
            btnPagar_.push({
              ...row2,
              uid: row2.token,
              key: key2,
              pagar: false,
            });
            
            totalLineas_[row2.producto] += parseInt(row2.cantidad);
            totalLineasPeso_[row2.producto] += parseFloat(row2.peso);
            totalLineasTotal_[row2.producto] += parseFloat(row2.total_restante);

            console.log("LOOK KEY initial ", row2)
            // activeOnBtn__ = true;
            // // if()
            //totalIva += parseInt(row2.iva_real);
            totalGeneralFooter += parseFloat(row2.total_restante);
            totalIva += row2.iva_real;
          });
          // console.log(btnPagar_);
          
          setTotalIva(response.impuestos.aplica_iva=="1" ? (totalIva):0);
          setSubtotalFooter(totalGeneralFooter);
          setTotalGeneralFooter(totalGeneralFooter);
          btnPagar__.push(btnPagar_);
          setReteiva(
            totalGeneralFooter > response.system.base && response.impuestos.aplica_reteiva
              ? totalIva * parseFloat(response.system.reteiva)
              : 0
          );
          setReteica(
            totalGeneralFooter > response.system.base_reteica && response.impuestos.aplica_reteica
              ? totalGeneralFooter * parseFloat(response.system.reteica)
              : 0
          );
          setRetefuente(totalGeneralFooter > response.system.base_retefuente && response.impuestos.aplica_retefuente
            ? totalGeneralFooter * parseFloat(response.system.retefuente)
            : 0);
          
          setTotalPagar(
            totalGeneralFooter +
            totalIva -
            (response.impuestos.aplica_reteiva && totalGeneralFooter > response.system.base
              ? totalIva * parseFloat(response.system.reteiva)
              : 0) -
            (response.impuestos.aplica_reteica && totalGeneralFooter > response.system.base_reteica
              ? totalGeneralFooter * parseFloat(response.system.reteica)
              : 0) -
            retefuente
          );
        });

        setBtn(activeOnBtn__);
        setBtnPagar(btnPagar__);
        setTotalLineas(totalLineas_);
        setTotalLineasPeso(totalLineasPeso_);
        setTotalLineasTotal(totalLineasTotal_);
        setData(data_);
      } else {
        history.push("/Pagos/ListaEfectados");
        console.log("PAID ALL")
      }
    });
  };
  useEffect(() => {
    if (params.fecha_inicio && params.fecha_fin) {
      setInputs(prev => ({
        ...prev,
        fecha_inicio: params.fecha_inicio,
        fecha_fin: params.fecha_fin
      }));
    }
  }, [params]);

  const selection = (label, id) => {
    console.log("Other DATA stuff ",data);
    dataFiltrada.map((row) => {
      //console.log(btnPagar);
      totalLineas[label] = 0;
      totalLineasPeso[label] = 0;
      totalLineasTotal[label] = 0;
    })
    const key = data.findIndex((pro) => pro.label === label);
    const key2 = data[key].items.findIndex(
      (reg) => reg.op_inventario_items_inventario_id === id
    );

    if (btnPagar[key] && btnPagar[key][key2]) {
      let btnPagar_ = [...btnPagar];

      btnPagar_[key][key2].pagar = btnPagar_[key][key2].pagar ? false : true;

      setBtnPagar(btnPagar_);
      // console.log(btnPagar);
      let totalGeneralFooter = 0;
      let totalIva = 0;
      let allCheck = true;
      console.log("Pay button", btnPagar_);
      // console.log("taxes",taxes);
      
      btnPagar_.map((row, key) => {
        row.map((row2, key2) => {
          if (row2.pagar === true) {
            if (row2.producto === label) {
              totalLineas[label] += parseInt(row2.cantidad);
              totalLineasPeso[label] += parseFloat(row2.peso);
              totalLineasTotal[label] += parseFloat(row2.total_restante);
            }
            totalGeneralFooter += parseFloat(row2.total_restante);
            totalIva += parseFloat(row2.iva_real);
            // console.log(allCheck);
          } else {
            allCheck = false;
          }
          return row2;
        });
        return row;
      });
      setSelectAll(allCheck);
      setTotalGeneralFooter(totalGeneralFooter);
      setTotalIva(retentions.aplica_iva == 1 ? totalIva : 0);//I don't think the conditional is necessary retentions.aplica_iva == 1 ? totalIva : 0//Maybe it is...
      setTotalLineas(totalLineas);
      setTotalLineasPeso(totalLineasPeso);
      setTotalLineasTotal(totalLineasTotal);//Set total product count to all when first loaded
      setReteiva(
        totalGeneralFooter > taxes.base && retentions.aplica_reteiva
        ? totalIva * parseFloat(taxes.reteiva)
        : 0
      );
      setReteica(
        totalGeneralFooter > taxes.base_reteica && retentions.aplica_reteica
        ? totalGeneralFooter * parseFloat(taxes.reteica)
        : 0
      );
      setRetefuente(
        totalGeneralFooter > taxes.base_retefuente && retentions.aplica_retefuente
        ? totalGeneralFooter * parseFloat(taxes.retefuente)
        : 0
      );
      setTotalPagar(
        totalGeneralFooter +
        totalIva -
        (totalIva * parseFloat(taxes.reteiva)) -
            (totalGeneralFooter * parseFloat(taxes.reteica)) -
              retefuente
            );
            let data_ = [...data];
            if (data_[key] && data_[key].items && data_[key].items[key2]) {
              // console.log(data_[key].items[key2].pagar);
              data_[key].items[key2].pagar =
              data_[key].items[key2].pagar === undefined ||
              data_[key].items[key2].pagar === false
              ? true
              : false;
            }
            verifyStatus(btnPagar_);
          }
        };
        console.log("LOOK KEYy ", totalLineas)
        console.log(retentions, taxes, "lollllllllllllll")

  // console.log("taxes.retefuente", taxes.retefuente * );

  // console.log("comparación", totalGeneralFooter > taxes.retefuente)
  const handleCloseCross = () => {
    setShowModal(false);
  };

  const handleClose = () => {
    !checkActive() && setShowModal(false);
  };

  const handleShow = () => {
    checkActive() && setShowModal(true);
  };

  const checkActive = () => {
    const boolean = data.find((search) =>
      search.items.find((search2) => search2.pagar === true)
    );
    return boolean !== undefined ? true : false;
  };

  const verifyStatus = (data) => {
    const result = data.find((search) =>
      search.find((search2) => search2.pagar === true)
    );
    if (result) {
      setBtn(true);
    } else {
      setBtn(false);
    }
  };

  // const handleDelete = (filter) => {
  //   if (filter === "producto") {
  //     setProductoFilter("");
  //     setOpInventarioItemsFilter(null);
  //     delete inputs.producto_id;
  //     setInputs({ ...inputs });
  //     Array.from(document.querySelectorAll("#Producto")).forEach(
  //       (select) => (select.value = "")
  //     );
  //   } else if (filter === "marca") {
  //     setMarcaFilter("");
  //     delete inputs.marca_id;
  //     setInputs({ ...inputs });
  //     Array.from(document.querySelectorAll("#Marca")).forEach(
  //       (select) => (select.value = "")
  //     );
  //   } else if (filter === "semana") {
  //     setSemanaFilter("");
  //     delete inputs.semana;
  //     setInputs({ ...inputs });
  //     Array.from(document.querySelectorAll("#Semana")).forEach(
  //       (select) => (select.value = "")
  //     );
  //   }
  // };

  const onChangeCustom = (e) => {
    console.log(e.target);
    Inputs(e, inputs, setInputs);
    
    if (e.target.name === "producto_id") {
      let index = e.target.selectedIndex;
      let producto = e.target.options[index].text;
      // console.log(e.target);
      setOpInventarioItemsFilter(e.target.value);
    } else if (e.target.name === "marca_id") {
      let index = e.target.selectedIndex;
      let marca = e.target.value;
      setMarcaFilter(marca);
    } else if (e.target.name === "semana") {
      let index = e.target.selectedIndex;
      let semana = e.target.options[index].text;
      setSemanaFilter(semana);
    } else if (e.target.name === "fecha_inicio") {
      setFechaInicioFiltro(e.target.value);
    } else if (e.target.name === "fecha_fin") {
      setFechaFinFiltro(e.target.value);
    }
  };

  const handleSubmitPago = (event) => {
    setPaying(true)
    event.preventDefault();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setFormValidated(true);  
      setPaying(false);  
      return;
    }

    const fechaSeleccionada = new Date(fecha);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    if (fechaSeleccionada > hoy) {
      context.setModalShow({
        show: true,
        size: "md",
        message: (
          <div className="text-center">
            <div className="mb-3">
              La fecha de pago no puede ser mayor a la actual{" "}
              {hoy.toLocaleDateString()}
            </div>
            <div
              className="btn btn-primary mt-3"
              onClick={() =>
                context.setModalShow({ show: false, message: "", size: "sm" })
              }
            >
              Cerrar
            </div>
          </div>
        ),
      });

      setPaying(false);
      return;
    }

    handleClose();

    PostAsync(
      "Pagos",
      "SetPagos",
      {
        detail: 1,
        fecha: fecha,
        fecha_vencimiento: fechaVencimiento,
        semestre: semestre,
        observacion: observacion,
        observacionCompra: observacionCompra,
        data: JSON.stringify(data),
      },
      context
    ).then((response) => {
      console.log(response);
      getInit();
      setFormValidated(false);
      setShowModal(false);
      setSelectAll(false);
      setPaying(false);
    })
  };

  const handleCheck = () => {
    console.log("DATA stuff ",dataFiltrada);
    let data_ = [];
    let seleccion = selectAll;
    let btnPagar_ = [...btnPagar];
    let totalGeneralFooter = 0;
    let totalIva = 0;
    let totalLineas = [];
    let totalLineasPeso = [];
    dataFiltrada.map((row) => {
      const key = data.findIndex((pro) => pro.label === row.label);
      // console.log(btnPagar);
      totalLineas[row.label] = 0;
      totalLineasPeso[row.label] = 0;
      totalLineasTotal[row.label] = 0;
      row.items.map((row2) => {
        const key2 = data[key].items.findIndex(
          (reg) =>
            reg.op_inventario_items_inventario_id ===
            row2.op_inventario_items_inventario_id
        );
        if (
          data[key].items &&
          data[key].items[key2] &&
          data[key].items[key2].pagar
        ) {
          data[key].items[key2].pagar = seleccion ? false : true;
        } else {
          data[key].items[key2].pagar = seleccion ? false : true;
        }
        totalGeneralFooter += !seleccion
          ? parseFloat(data[key].items[key2].total_restante)
          : 0;
        totalIva += !seleccion ? parseFloat(data[key].items[key2].iva_real) : 0;//selection
        totalLineas[row.label] += !seleccion ? parseInt(row2.cantidad) : 0;
        totalLineasPeso[row.label] += !seleccion ? parseFloat(row2.peso) : 0;
        totalLineasTotal[row.label] += !seleccion
          ? parseFloat(row2.total_restante)
          : 0;
        // console.log(totalIva);
        // row.items[key2].pagar = seleccion ? false : true;
        return (btnPagar_[key][key2].pagar = seleccion ? false : true);
      });
      data_.push(row);
      return row;
    });
    setTotalIva(retentions.aplica_iva == 1 ? totalIva : 0);
    setTotalGeneralFooter(totalGeneralFooter);
    setBtnPagar(btnPagar_);
    setSelectAll(seleccion ? false : true);
    verifyStatus(btnPagar_);
    setTotalLineas(totalLineas);
    setTotalLineasPeso(totalLineasPeso);//BOOKMARK
    setTotalLineasTotal(totalLineasTotal);
    setBaseRetefuente(
      parseFloat(taxes.base_retefuente.toString().replace(/\./g, ""))
    );
    setReteiva(
      totalGeneralFooter > taxes.base && retentions.aplica_reteiva
        ? totalIva * parseFloat(taxes.reteiva)
        : 0
    );
    setReteica(
      totalGeneralFooter > taxes.base_reteica && retentions.aplica_reteica
        ? totalGeneralFooter * parseFloat(taxes.reteica)
        : 0
    );
    setRetefuente(
      totalGeneralFooter > taxes.base_retefuente && retentions.aplica_retefuente
      ? totalGeneralFooter * parseFloat(taxes.retefuente)
      : 0);
    
    setTotalPagar(
      totalGeneralFooter +
        totalIva -
        (retentions.aplica_reteiva && totalGeneralFooter > taxes.base
          ? totalIva * parseFloat(taxes.reteiva)
          : 0) -
        (retentions.aplica_reteica && totalGeneralFooter > taxes.base_reteica
          ? totalGeneralFooter * parseFloat(taxes.reteica)
          : 0) -
        retefuente
    );
  };
  const openDownload = (e) => {
    // e.preventDefault()
    // let uri = e.target.href + "?";

    // if (inputs.fecha_inicio) {
    //   uri += "fecha_inicio=" + inputs.fecha_inicio + "&"
    // }
    // if (inputs.fecha_fin) {
    //   uri += "fecha_fin=" + inputs.fecha_fin + "&"
    // }
    // if (Object.entries(inputs2).length > 0) {
    //   Object.entries(inputs2).map((row, key) => {
    //     if (row[1] && row[1].length > 0) {
    //       row[1].map((row2, key2) => {
    //         return uri += row2.name + "[]=" + row2.value + "&"
    //       })
    //     } else {
    //       return false
    //     }
    //   })
    // }
    // //console.log(uri);
    // window.open(uri)
  }

  console.log("totalGeneralFooter", totalGeneralFooter, taxes,taxes.base_retefuente, (totalGeneralFooter > taxes.base_retefuente && retentions.aplica_retefuente == 1), retefuente);
  
  const today = new Date().toISOString().split("T")[0];
  return (
    <>
      <Modal show={showModal} onHide={handleCloseCross}>
        <Modal.Header closeButton>
          <Modal.Title>Información del pago</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={formValidated}
            onSubmit={handleSubmitPago}
          >
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Fecha de Pago</Form.Label>
              <Input
                title="Fecha de Pago"
                placeholder="Fecha de Pago"
                type="date"
                name="pago_fecha"
                className="form-control"
                max={today}
                onChange={(e) => setFecha(e.target.value)}
                required={true}
              />
              <Form.Label className="mt-2">Fecha de Vencimiento</Form.Label>
              <Input
                title="Fecha de Vencimiento"
                placeholder="Fecha de Vencimiento"
                type="date"
                name="fecha_vencimiento"
                className="form-control"
                onChange={(e) => setFechaVencimiento(e.target.value)}
              />
              <Form.Label className="mt-3">Semestre</Form.Label>
              <InputGroup hasValidation>
                <Form.Select
                  aria-label="Default select example"
                  onChange={(e) => setSemestre(e.target.value)}
                  required
                >
                  <option value="">Seleccionar el semestre</option>
                  <option value="1">Primero</option>
                  <option value="2">Segundo</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Porfavor elija un semestre de pago.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Concepto de pago</Form.Label>
              <Form.Control
                style={{ resize: "none", backgroundColor: "#cccccc" }}
                placeholder="Ingrese aquí los concepto de pagos."
                as="textarea"
                onChange={(e) => setObservacion(e.target.value)}
                rows={3}
              />
            </Form.Group>
            
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea2"
            >
              <Form.Label>Observaciones de pago</Form.Label>
              <Form.Control
                style={{ resize: "none", backgroundColor: "#cccccc" }}
                placeholder="Ingrese aquí las observaciones del pago."
                as="textarea"
                onChange={(e) => setObservacionCompra(e.target.value)}
                rows={3}
              />
            </Form.Group>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseCross}>
                Cerrar
              </Button>
              <Button variant="primary" type="submit" disabled={paying} onClick={handleClose}>
                Pagar
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <div className="container-fluid" style={{ marginTop: "65px" }}>
        <div className="row justify-content-center mb-3">
          <div className="col-12 h3">
            <b>
              Proveedor {(proveedor.ma_naturaleza_id == 1)?proveedor.nombres + ' ' + proveedor.apellidos:proveedor.nombres}
            </b>
          </div>
          <div className="col mb-3">
            <a onClick={openDownload} className="btn btn-primary btn-sm me-1 col-1" href={Config.ConfigApirest + 'Excel/Pagos/exportarExcelPagoRealizar/token:' + context.user.token +
                '/id:' + params.id+
                "?filtro="+ JSON.stringify(inputs)} target="_blank">
              <FontAwesomeIcon icon={faFileDownload} /> Excel
            </a>
            <a
              className="btn btn-primary btn-sm me-10 col-1"
              target="_blank"
              href={
                Config.ConfigApirest +
                "PDF/Pagos/ListaPagosDetallePDF/" +
                params.id +
                "?filtro="+ JSON.stringify(inputs)+
                "&subtotal=" +
                totalGeneralFooter +
                "&iva=" +
                totalIva +
                "&total=" +
                (totalGeneralFooter + totalIva) +
                "&rete_iva=" +
                reteiva +
                "&rete_ica=" +
                reteica +
                "&rete_fuente=" +
                retefuente +
                "&totalPagar=" +
                totalPagar 
              }
            >
              <FontAwesomeIcon icon={faPrint} /> PDF
            </a>
          </div>
        </div>
        <div className="row bg-gray">
          <div className="col-12 ">
            <b>Filtros de búsqueda</b>
          </div>
          <div className="col-12 col-sm-2 mb-3 pt-1 text-left">
            <Input
              title="Fecha desde"
              placeholder="Fecha desde"
              type="date"
              name="fecha_inicio"
              className="form-control"
              onChange={onChangeCustom}
              required={true}
              defaultValue={params.fecha_inicio}
            />
          </div>
          <div className="col-12 col-sm-2 mb-3 pt-1 text-left">
            <Input
              title="Fecha hasta"
              placeholder="Fecha hasta"
              type="date"
              name="fecha_fin"
              className="form-control"
              onChange={onChangeCustom}
              required={true}
              defaultValue={params.fecha_fin}
            />
          </div>
          <div className="col-12 col-sm-2 mb-3 pt-1 text-left border-end">
            <SelectorMultiple
              name="semana"
              title="Semana"
              selectDefault="Semana"
              data={semanas}
              inputs={inputs}
              setInputs={setInputs}
              //required={true}
              className="form-control"
            />
          </div>
          <div className="col-12 col-sm-3 mb-3 pt-1 text-left">
            <SelectorMultiple
              id="Marca"
              title="Marca"
              selectDefault="Marca"
              name="marca_id"
              data={marcas}
              inputs={inputs}
              setInputs={setInputs}
              //required={true}
              className="form-control"
            />
          </div>
          <div className="col-12 col-sm-3 mb-3 pt-1 text-left">
            <SelectorMultiple
              url="/Inventario/ListadoProductos"
              title="Producto"
              selectDefault="Producto"
              name="producto_id"
              data={productos}
              inputs={inputs}
              setInputs={setInputs}
              //required={true}
              className="form-control"
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="col">Producto</th>
                  <th className="col">Fecha de compra</th>
                  <th className="col">Semana</th>
                  <th className="col">Marca</th>
                  <th className="col">Observación</th>
                  <th className="col">Cantidad</th>
                  <th className="col">Peso</th>
                  <th className="col">Precio Unitario</th>
                  <th className="col">Precio Total</th>
                  <th className="text-center col-2">
                    <div className="row">
                      <div className="col-11 text-end">
                        <div
                          className={
                            selectAll
                              ? "btn btn-primary btn-sm me-2"
                              : "btn btn-secondary btn-sm me-2"
                          }
                          onClick={handleCheck}
                        >
                          <FontAwesomeIcon icon={faCheck} />
                        </div>
                        {parseInt(context.user.tipo_usuario_id) > 3 ||
                        parseInt(context.user.tipo_usuario_id) === 1 ||
                        parseInt(context.user.tipo_usuario_id) === 2 ? (
                          <div
                            className={
                              btn
                                ? "btn btn-primary btn-sm"
                                : "btn btn-secondary btn-sm"
                            }
                            onClick={handleShow}
                          >
                            <FontAwesomeIcon icon={faDollarSign} /> Pagar
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  // console.log(dataFiltrada)
                }
                {dataFiltrada.map((row, key) => {
                  // console.log(row);
                  return (
                    <tr key={key}>
                      <td>{row.label}</td>
                      <td className="text-center">
                        {row.items.map((row2, key2) => {
                          return (
                            <div className="mb-4" key={key2}>
                              {row2.fecha}
                            </div>
                          );
                        })}
                      </td>
                      <td className="text-center">
                        {row.items.map((row2, key2) => {
                          return (
                            <div className="mb-4" key={key2}>
                              {row2.semana}
                            </div>
                          );
                        })}
                      </td>
                      <td>
                        {row.items.map((row2, key2) => {
                          return (
                            <div className="mb-4" key={key2} title={row2.marca}>
                              {row2.marca.length > 15
                                ? row2.marca.substr(0, 15) + "..."
                                : row2.marca}
                            </div>
                          );
                        })}
                      </td>
                      <td>
                        {row.items.map((row2, key2) => {
                          // {console.log(row2)}
                          return (
                            <div
                              key={key2}
                              className="mb-4"
                              style={{ minHeight: "24px" }}
                              title={row2.observacion || ""}
                            >
                              {row2.observacion
                                ? row2.observacion.length > 15
                                  ? row2.observacion.substr(0, 15) + "..."
                                  : row2.observacion
                                : " "}
                            </div>
                          );
                        })}
                      </td>
                      <td className="text-end">
                        <div className="bg-secondary">
                          {row.items.map((row2, key2) => {
                            return (
                              <div className="mb-4 text-white pe-2" key={key2}>
                                {row2.cantidad}
                              </div>
                            );
                          })}
                          <div className="bg-secondary text-white  p-2">
                            <b>{totalLineas[row.label]}</b>
                          </div>
                        </div>
                      </td>
                      <td className=" text-end ">
                        <div className="bg-secondary">
                          {row.items.map((row2, key2) => {
                            return (
                              <div className="mb-4 text-white pe-2" key={key2}>
                                {row2.peso}
                              </div>
                            );
                          })}
                          <div className="bg-secondary text-white  p-2">
                            <b>{format(totalLineasPeso[row.label])}</b>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="text-end">
                          {row.items.map((row2, key2) => {
                            return (
                              <div className="mb-4 pe-2" key={key2}>
                                <div>{format(row2.precio)}</div>
                              </div>
                            );
                          })}
                        </div>
                      </td>
                      <td className="text-end  text-white">
                        <div className="bg-secondary">
                          {row.items.map((row2, key2) => {
                            return (
                              <div className="mb-4 text-white pe-0" key={key2}>
                                <div
                                  className={
                                    row2.pagar === true
                                      ? "btn-primary pe-3"
                                      : "pe-3"
                                  }
                                >
                                  {format(row2.total_restante)}
                                </div>
                              </div>
                            );
                          })}
                          <div className="bg-secondary text-white  p-2">
                            <b>{format(totalLineasTotal[row.label])}</b>
                          </div>
                        </div>
                      </td>
                      <td className="text-center border-start">
                        {row.items.map((row2, key2) => {
                          // console.log(row);
                          return (
                            <div key={key2} className="mb-3">
                              <div
                                className={
                                  row2.pagar === true
                                    ? "btn btn-primary btn-sm me-2"
                                    : "btn btn-secondary btn-sm me-2"
                                }
                                onClick={() =>
                                  selection(
                                    row.label,
                                    row2.op_inventario_items_inventario_id
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faCheck} />
                              </div>
                            </div>
                          );
                        })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Row>
              <Col>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td className="bg-primary text-white h6">PRODUCTO</td>
                      <td className="bg-primary text-white h6">
                        CANTIDAD TOTAL
                      </td>
                      <td className="bg-primary text-white h6">
                        KILOS TOTALES
                      </td>
                      <td className="bg-primary text-white h6">TOTAL</td>
                    </tr>

                    {data.map((row, key) => {
                      return (
                        <tr key={key}>
                          <td className="bg-primary text-white h6">
                            {row.label}
                          </td>
                          <td>
                            {totalLineas[row.label] === undefined
                              ? 0
                              : totalLineas[row.label]}
                          </td>
                          <td>
                            {totalLineasPeso[row.label] === undefined
                              ? 0
                              : format(totalLineasPeso[row.label])}
                          </td>
                          <td>
                            {totalLineasTotal[row.label] === undefined
                              ? 0
                              : format(totalLineasTotal[row.label])}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Col>
              <Col>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td className="bg-primary text-white h6">SUBTOTAL</td>
                      <td className="bg-primary text-white text-end h6">
                        {format(totalGeneralFooter)}
                      </td>
                    </tr>
                    <tr>
                      <td className="bg-primary text-white h6">IVA</td>
                      <td className="text-end">{format(totalIva)}</td>
                    </tr>
                    <tr>
                      <td className="bg-primary text-white h6">TOTAL</td>
                      <td className="text-end">
                        {format(totalGeneralFooter + totalIva)}
                      </td>
                    </tr>
                    <tr>
                      <td className="bg-primary text-white h6">RETEIVA</td>
                      <td className="text-end">
                        {format(reteiva)}
                      </td>
                    </tr>
                    <tr>
                      <td className="bg-primary text-white h6">RETEICA</td>{/*Whoever forgot  to change the check from reteiva to reteica owes me a dime*/}
                      <td className="text-end">
                        {format(reteica)}
                      </td>
                    </tr>
                    <tr>
                      <td className="bg-primary text-white h6">RETEFUENTE</td>
                      <td className="text-end">
                        {/* {console.log("aplica rete",retentions.aplica_retefuente, "total", totalGeneralFooter, "base", baseRetefuente, "rete", retefuente)} */}
                        {format(retefuente)}
                      </td>
                    </tr>
                    <tr>
                      <td className="bg-primary text-white h6">
                        TOTAL A PAGAR
                      </td>
                      <td className="text-end">
                        {format(
                          totalGeneralFooter +
                            totalIva -
                            (reteiva) -
                            (reteica) -
                            (retefuente)
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};
export default App;
